import { modalTypes } from "constants/types";
import { hideModal, showModal } from "slices/app/actions/modals";
import { getErrorMessage } from "utils";

export const showErrorModal = (error) => (dispatch) => {
  dispatch(
    showModal(modalTypes.ERROR, {
      errorMessage: getErrorMessage(error),
      handleOk: hideModal(modalTypes.ERROR),
    })
  );
};
